var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBnyMellonLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 62,
    viewBox: "0 0 135 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1367_8184)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1367_8184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68 48.5519V48.1629H68.787V42.0217H68V41.635H72.3026V41.3418H72.7851V43.0103H72.3127V42.1175H69.8273V44.8006H71.8096V44.0094H72.2896V46.0741H71.8096V45.2727H69.8273V48.0824H72.4088V47.1589H72.8889V48.5519H68Z",
    fill: "#1F2022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.306 42.0241V48.666H99.8571L95.8326 43.1319V48.1627H96.6314V48.5517H94.5175V48.1627H95.3114V42.4212L95.0286 42.0241H94.3047V41.6348H96.0303L99.779 46.7719V42.0241H98.9827V41.6348H101.089V42.0241H100.306Z",
    fill: "#1F2022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8361 48.6872C87.911 48.6872 86.3906 47.0527 86.3906 45.1043C86.3906 43.1322 87.9004 41.5107 89.8361 41.5107C91.7381 41.5107 93.2505 43.1452 93.2505 45.0964C93.2505 47.0447 91.7378 48.6872 89.8361 48.6872ZM89.8466 42.0557C88.4741 42.0557 87.5477 43.314 87.5477 45.0964C87.5477 46.8661 88.4738 48.1424 89.8361 48.1424C91.1775 48.1424 92.0932 46.8553 92.0932 45.0964C92.0932 43.3347 91.1775 42.0557 89.8466 42.0557Z",
    fill: "#1F2022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7481 48.5517V48.1627H64.5329V43.0101L61.9654 48.6555L59.2685 42.8931V48.1627H60.0651V48.5517H57.9492V48.1627H58.7419V42.0215H57.9492V41.6348H59.8043L62.2249 46.8007L64.6055 41.6348H66.3619V42.0215H65.5747V48.1627H66.3619V48.5517H63.7481Z",
    fill: "#1F2022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7344 48.5517V48.1627H75.5206V42.0215H74.7344V41.6348H77.3496V42.0215H76.5634V48.0821H79.0206V47.1586H79.5006V48.5517H74.7344Z",
    fill: "#1F2022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7734 48.5517V48.1627H81.5596V42.0215H80.7734V41.6348H83.3889V42.0215H82.6026V48.0821H85.0623V47.1586H85.5423V48.5517H80.7734Z",
    fill: "#1F2022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2217 42.0216L51.2097 45.3037V48.1629H52.0049V48.5519H49.3897V48.1629H50.1771V45.3684L48.0016 42.0216H47.3984V41.6377H50.1083V42.0216H49.2314L50.9892 44.7174L52.6252 42.0216H51.6688V41.6377H53.7639V42.0216H53.2217Z",
    fill: "#1F2022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8575 44.9171C37.6048 45.0002 38.7332 45.4413 38.7332 46.7512C38.7332 47.8565 37.8513 48.5517 36.5981 48.5517H33.2422V48.1627H34.0294V42.0215H33.2422V41.6348H36.414C37.5179 41.6348 38.3974 42.234 38.3974 43.3524C38.3974 44.2709 37.6048 44.7925 36.8575 44.8934V44.9171ZM36.0041 42.1173H35.0726V44.7275H35.947C36.5983 44.7275 37.3025 44.3201 37.3025 43.3937C37.3025 42.4834 36.7252 42.1173 36.0041 42.1173ZM36.0457 45.1998H35.0726V48.0821H36.0457C36.9251 48.0821 37.6607 47.6075 37.6607 46.697C37.6604 45.7525 36.9743 45.1998 36.0457 45.1998Z",
    fill: "#1F2022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9373 42.0241V48.666H45.491L41.4669 43.1319V48.1627H42.262V48.5517H40.1453V48.1627H40.9442V42.4212L40.6614 42.0241H39.9375V41.6348H41.6616L45.4133 46.7719V42.0241H44.6167V41.6348H46.7235V42.0241H45.9373Z",
    fill: "#1F2022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4559 19.2764C66.8582 20.6579 64.5438 22.4598 62.6367 24.3485C64.4972 26.1738 66.6649 27.9211 69.4559 29.4195L82.4259 24.3485L69.4559 19.2764Z",
    fill: "#1F2022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7984 23.4889C58.8821 20.3886 56.8958 16.9105 55.8945 13.9775L69.0868 19.1342C66.7071 20.1005 64.1696 21.5767 61.7984 23.4889Z",
    fill: "#1F2022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7984 25.207C58.8821 28.3076 56.8958 31.7868 55.8945 34.7206L69.0868 29.562C66.7071 28.5969 64.1696 27.1206 61.7984 25.207Z",
    fill: "#1F2022"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1367_8184"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 62,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1367_8184"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 61.7,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnyMellonLogo);
export default __webpack_public_path__ + "static/media/bny-mellon-logo.f004690b6484644c9ba35053f2ed5da6.svg";
export { ForwardRef as ReactComponent };